module.exports = __webpack_public_path__ + "img/ic_programs_active.f80f6037.webp";